import React from 'react';
import gifLoading from "../../assets/gif/Lightcast_LoadingGif_Sailor_Red.gif"
import Image from "react-bootstrap/Image";

const LoadingScreen = ({width = null}) => {
        
    return (
        <div className="loading-screen" style={{width}}>
            <Image className="loading-screen__gif" src={gifLoading} />
        </div>
    );
};


export default LoadingScreen;